<template>
  <div class="p-family-club__form-container">
    <Steps :steps="steps" :current-step="currentStep"></Steps>
    <form autocomplete="off" @submit.prevent="onSubmitForm">
      <Loader v-if="isLoading"></Loader>
      <Alert
        v-if="!isLoading && errorMsgs.length"
        key="submit-errors"
        dismiss-by-native=""
        type="danger"
        :messages="errorMsgs"
        @close="removeErrors"></Alert>

      <div class="s-vip-register-form">
        <div class="b-block b-block--transparent b-block--sm-pad">
          <div class="b-block__form-section mb-0">
            <div class="mb-48">
              <h3 class="s-vip-register-form__title">
                {{ dictionary.formTitle }}
              </h3>
              <div class="s-vip-register-form__desc">
                {{ dictionary.formDesc }}
              </div>
            </div>

            <!-- row -->
            <div class="form-floating">
              <input
                id="code"
                v-model="code"
                name="code"
                type="text"
                class="form-control"
                :placeholder="dictionary.codePlaceholder"
                :class="{ 'form-control--error': v$.code.$error }"
                @blur="v$.code.$touch" />

              <label for="code" class="form-label">
                {{ dictionary.codeLabel }}
              </label>

              <!-- validations -->
              <template v-if="v$.code.$error">
                <div
                  v-if="v$.code.required.$invalid"
                  class="field-validation-error">
                  {{ dictionary.codeRequired }}
                </div>
                <div
                  v-if="
                    v$.code.minLength.$invalid || v$.code.maxLength.$invalid
                  "
                  class="field-validation-error">
                  {{ dictionary.codeLength }}
                </div>
                <div
                  v-if="v$.code.numeric.$invalid"
                  class="field-validation-error">
                  {{ dictionary.codeNumeric }}
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="b-block__form-btn">
          <button
            type="submit"
            class="p-contact__submit-btn"
            :disabled="v$.code.$invalid">
            <span>{{ dictionary.nextBtn }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// STORE

import * as lib from '../../lib/lib'
import Loader from './../components/Shared/Loader.vue'
import Alert from './../components/Shared/Alert.vue'
import useVuelidate from '@vuelidate/core'
import postRequestHandler from '../../lib/postRequestHandler'
import getErrorMessage from '../../lib/getErrorMessage'
import Steps from '../components/RegisterForm/Steps.vue'

import { maxLength, minLength, numeric, required } from '@vuelidate/validators'

export default {
  /* eslint-disable vue/no-reserved-component-names */
  components: {
    Loader,
    Alert,
    Steps,
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isLoading: false,
      errorMsgs: [],
      code: '',
      steps: [],
      currentStep: -1,
    }
  },
  validations() {
    return {
      code: {
        required,
        numeric,
        minLength: minLength(16),
        maxLength: maxLength(16),
      },
    }
  },

  computed: {},

  mounted() {
    const { steps } = lib.getData('vipRegisterForm')
    this.steps = steps
    const {vipCode} = lib.getData('vipRegisterForm')
    this.code= vipCode
    lib.checkCaptcha(() => (this.isLoading = false))
  },

  methods: {
    removeErrors() {
      this.errorMsgs = []
    },

    async onSubmitForm() {
      this.v$.$validate()

      if (this.isLoading) {
        return false
      }

      if (this.v$.$invalid) {
        await this.$nextTick()
        lib.scrollToValidation()
        return false
      }

      this.removeErrors()
      this.isLoading = true

      const postData = {
        language:document.documentElement.lang,
        code: this.code,
        clubId:this.configuration.clubId
      }

      await postRequestHandler({
        postData,
        endpoint: this.configuration.endpointSubmitData,
        successCallback: this.handleSuccess,
        errorCallback: this.handleError,
        refreshTokenHandler: this.configuration.refresh,
        captchaAction: this.configuration.captchaAction,
      })
    },

    async handleSuccess(response) {
      this.isLoading = false
      this.errorMsgs = []
      window.location.replace(response.data.redirectUrl)
    },

    async handleError(messages) {
      this.isLoading = false

      this.errorMsgs = getErrorMessage(
        messages,
        this.dictionary.defaultErrorMessage
      )

      await this.$nextTick()
      lib.scrollToError()
    },
  },
}
</script>
